import React from 'react'
import { Editor } from '@monaco-editor/react'

interface SchemaCodeEditorProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
}

export const SchemaCodeEditor: React.FC<SchemaCodeEditorProps> = ({
  value,
  onChange
}) => {
  const [prefersDarkMode, setPrefersDarkMode] = React.useState(
    globalThis.matchMedia('(prefers-color-scheme: dark)').matches
  )
  React.useEffect(() => {
    const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (event: MediaQueryListEvent) =>
      setPrefersDarkMode(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])
  const theme = prefersDarkMode ? 'vs-dark' : 'light'

  return (
    <Editor
      theme={theme}
      height='60vh'
      defaultLanguage='json'
      defaultValue={value}
      value={value}
      onChange={onChange}
      options={{
        minimap: { enabled: false },
        automaticLayout: true
      }}
    />
  )
}
